import {IStore} from "modules/types";

export const getShareUrl = ({share}: IStore) => share.url;
